import React from 'react';
import './doorFacingBox.scss';

// hinge: 'start' | 'end' — «برعکس کردنِ لولا» (در از سمتِ دیگر باز شود)
function DoorFacingBox({ x, y, facing, onChange, hinge, onFlipHinge }) {
  return (
    <div className="door-facing-box" style={{ left: x, top: y }}>
      <button
        type="button"
        className={`door-facing-box__option ${facing === 'out' ? 'is-active' : ''}`}
        onClick={() => onChange('out')}
      >
        رو به بیرون
      </button>
      <button
        type="button"
        className={`door-facing-box__option ${facing === 'in' ? 'is-active' : ''}`}
        onClick={() => onChange('in')}
      >
        رو به داخل
      </button>
      {onFlipHinge && (
        <button
          type="button"
          className={`door-facing-box__option door-facing-box__flip ${hinge === 'end' ? 'is-on' : ''}`}
          onClick={onFlipHinge}
          aria-label="برعکس کردنِ سمتِ لولا"
        >
          ⇄ لولا
        </button>
      )}
    </div>
  );
}

export default DoorFacingBox;